<template>
  <input
    :id="inputId"
    type="number"
    :value="value"
    class="form-control"
    :class="dynamicClass"
    :disabled="disabled"
    :min="min"
    :style="customStyle"
    @keydown="preventInvalidChars"
    @input="getInput"
  />
</template>
<script>
export default {
  name: "NumberInput",
  props: {
    inputId: {
      type: String,
    },
    value: {
      type: [String, Number],
    },
    dynamicClass: {
      type: [String, Object],
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    customStyle: {
      type: [String, Object],
    },
    min: {
      type: [String, Number],
      default: () => 0,
    },
    isDecimalAllowed: {
      type: Boolean,
      default: () => false,
    },
    isMinusAllowed: {
      type: Boolean,
      default: () => false,
    },
    isIncludedInputValidation: {
      type: Boolean,
      default: () => false,
    }
  },
  methods: {
    getInput(e) {
      let val = e.target.value;
      this.$emit('input', val);

      if (this.isIncludedInputValidation) {
        this.$nextTick(() => {
          e.target.value = this.value;
        });
      }
    },
    preventInvalidChars(e) {
      if (['e', 'E', '+'].includes(e.key)) {
        e.preventDefault();
      }
      if (e.key === '.' && !this.isDecimalAllowed) {
        e.preventDefault();
      }
      if (e.key === '-' && !this.isMinusAllowed) {
        e.preventDefault();
      }
    },
  }
}
</script>